/**
 * Auto-captured context embedded on every support submission (tickets,
 * feedback, launcher). Generalizes the pattern FeedbackPage pioneered —
 * support should never have to ask "what page were you on, what browser?".
 */
import { Timestamp } from 'firebase/firestore';
import type { SubmissionContext } from '../types/supportHub.types';
import { routePattern } from './screenReview/routePattern';

export function captureSubmissionContext(): SubmissionContext {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  return {
    url,
    route: routePattern(pathname),
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 300) : '',
    viewportW: typeof window !== 'undefined' ? window.innerWidth : 0,
    viewportH: typeof window !== 'undefined' ? window.innerHeight : 0,
    appVersion: typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'unknown',
    capturedAt: Timestamp.now(),
  };
}
